var _defs, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavIconArrowDown44X44(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "SelectLanguage__arrow",
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill-rule:evenodd;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "18-UIP-0004_BrandCtr_Nav_Icon_ArrowDown_44x44") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    className: "cls-1",
    points: "17.41 18 22 22.945 26.59 18 28 19.522 22 26 16 19.522 17.41 18"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIconArrowDown44X44);
export default __webpack_public_path__ + "static/media/Nav_Icon_ArrowDown_44x44.0ea36e8fcfbebce7e5658e45ff69ce9c.svg";
export { ForwardRef as ReactComponent };